import { createActionCreators } from 'store/utils/actionHelpers'
import CmsApis from 'apis/cmsApis'
import inCartApis from 'apis/incartApis'
import IncartCmsApis from 'apis/incartCmsApis'
import { fetchThemeSuccess } from 'store/theme/actions'
import types from './types'

const {
  fetchPreferencesRequest,
  fetchPreferencesSuccess,
  fetchPreferencesFailure,
} = createActionCreators(types)

export const fetchPreferences = () => (dispatch) => {
  dispatch(fetchPreferencesRequest())
  return IncartCmsApis.getStoresApi()
    .then(({ baseURL }) => {
      CmsApis.baseURL = baseURL
      return CmsApis.getStorePreferences()
    })
    .then(({ data }) => {
      // set storeId to CmsApi class
      // so that next time we call an api, storeId will be attached to headers
      const {
        storeId,
        inCartURL,
        inCartAccessToken,
        inCartApiKey,
        categoriesPath = '/categories',
        productsPath = '/products',
      } = data
      CmsApis.storeToken = storeId
      inCartApis.setConfig = {
        baseURL: inCartURL,
        accessToken: inCartAccessToken,
        apiKey: inCartApiKey,
        storeToken: storeId,
        categoriesPath,
        productsPath,
      }
      return CmsApis.getStoreTheme(storeId)
        .then(({ data: themeData }) => {
          dispatch(fetchThemeSuccess({ theme: themeData }))
          return dispatch(fetchPreferencesSuccess(data))
        })
      // return dispatch(fetchPreferencesSuccess(data))
    })
    .catch((error) => {
      console.log('error', error)
      return dispatch(fetchPreferencesFailure({ error }))
    })
}



// WEBPACK FOOTER //
// ./src/store/preferences/actions.js